// components/LicenseDeleteModal.tsx
import React, { useEffect, useRef } from "react";

interface LicenseDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  licenseId: string;
}

const LicenseDeleteModal: React.FC<LicenseDeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  licenseId,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      console.log("Modal opened, focusing on first button");
      const firstButton = modalRef.current.querySelector("button");
      if (firstButton) firstButton.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()} 
      >
        <h2><span style={{textTransform: "capitalize"}}>A</span>re you sure you want to delete this license?</h2>
        <div className="modal-buttons">
          <button className="modal-button2 mauve" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-button2 modal-btn-red" onClick={onConfirm}>
            Yes, delete license
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenseDeleteModal;